// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import RegionTable from "../../DataTables/MasterData/Regions/RegionTable";

// Modals
import CreateRegionsModal from "../../UiKits/Modal/MasterData/Regions/CreateRegion";

const RegionsContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Regions"
        parent="Master Data / Address & Location"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Regions Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage regions options used throughout the HRIS for employee
                  and applicant personal information.
                </P>
                <CreateRegionsModal />
                <RegionTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RegionsContainer;
